import UIPopover from 'UIComponents/tooltip/UIPopover';
import { useState } from 'react';
import UIList from 'UIComponents/list/UIList';
import { useCallback } from 'react';
import { useMemo } from 'react';
import SmallToggleButton from '../../draft-transplant/components/SmallToggleButton';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FileAttachments(props) {
  const {
    prosemirrorAttachmentButtons,
    renderAttachmentButton
  } = props;
  const [popoverOpen, setPopoverOpen] = useState(false);
  const handleToggleButton = useCallback(() => {
    setPopoverOpen(!popoverOpen);
  }, [popoverOpen, setPopoverOpen]);
  const handlePopoverOpenChange = evt => {
    setPopoverOpen(evt.target.value);
  };
  const closePopover = useCallback(() => {
    setPopoverOpen(false);
  }, [setPopoverOpen]);
  const attachmentButtons = useMemo(() => {
    return prosemirrorAttachmentButtons && prosemirrorAttachmentButtons.map((Component, key) => {
      return /*#__PURE__*/_jsx(Component, {
        closePopover: closePopover
      }, key);
    });
  }, [prosemirrorAttachmentButtons, closePopover]);
  if (renderAttachmentButton) {
    return renderAttachmentButton;
  }
  return /*#__PURE__*/_jsx(UIPopover, {
    closeOnOutsideClick: true,
    content:
    /*#__PURE__*/
    // eslint-disable-next-line hubspot-dev/no-private-classes
    _jsx(UIList, {
      className: "private-dropdown--list",
      children: attachmentButtons
    }),
    onOpenChange: handlePopoverOpenChange,
    open: popoverOpen,
    children: /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(SmallToggleButton
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      , {
        active: false,
        icon: "attach",
        "data-test-id": "select-file-dropdown",
        onClick: handleToggleButton
      })
    })
  });
}